import type { AnalyticsService, EventParameters } from '../analytics-service'
import { ANALYTICS_EVENTS } from '../events'

type GtmEvent = {
  event: string
  [eventData: string]: string | number
}

const pushToDataLayer = (event: GtmEvent) => window.dataLayer?.push(event)

class GtmAnalyticsService implements AnalyticsService {
  logEvent(name: string, parameters: EventParameters) {
    // Exclude site from event parameters as GTM uses two different containers
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { site, ...rest } = parameters ?? {}
    pushToDataLayer({
      event: name,
      ...rest,
    })
  }

  setGlobalData(data: EventParameters) {
    // consumed by google tag manager
    window.GTM = {
      ...window.GTM,
      ...data,
    }

    // trigger custom event to notify about GTM data change
    pushToDataLayer({ event: ANALYTICS_EVENTS.GTM_DATA_CHANGE })
  }
}

export default GtmAnalyticsService
